// libs
import React, { memo } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

// components
import LandingPageMobile from 'shared/layouts/LandingPage/Mobile';
import LandingPageDesktop from 'shared/layouts/LandingPage/Desktop';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

function OfferPage() {
  const { dWebPageName, mWebPageName } = useRemoteConfig('offers');

  return (
    <RouteChunkRenderer
      mobileComponent={<LandingPageMobile pageName={mWebPageName} fallback={<ChunkFallback />} />}
      desktopComponent={<LandingPageDesktop pageName={dWebPageName} fallback={<ChunkFallback />} />}
    />
  );
}

export default memo(OfferPage);
